<template>
  <div
    class="custom-player"
    :class="{ fullscreen: fullScreenMode }"
    @mousemove="showLargeBtn = true"
    @mouseleave="showLargeBtn = false"
  >
    <transition name="fade">
      <span
        class="play-btn"
        @click="playVideo"
        v-if="
          (showLargeBtn && !this.fullScreenMode) ||
            (this.fullScreenMode && !this.$refs.player.player.playing)
        "
      >
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15.5" cy="15.5" r="15.5" fill="#DDBC9E" />
          <path
            d="M23.25 15.5L11.625 22.2117L11.625 8.7883L23.25 15.5Z"
            fill="white"
          />
        </svg>
      </span>
    </transition>
    <vue-plyr ref="player">
      <div :data-plyr-provider="type" :data-plyr-embed-id="id"></div>
    </vue-plyr>

    <div v-if="!fullScreenMode" class="controls-custom-player controls-sm">
      <div class="left-controls">
        <span class="prev" @click="proceedVideo(-5)">
          <svg
            width="9"
            height="9"
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 4.49964L6.66667 7.77129L6.66667 1.22799L1 4.49964Z"
              fill="white"
            />
            <path d="M1 0.721863V8.27742" stroke="white" stroke-width="0.5" />
          </svg>
        </span>
        <span class="play" @click="playVideo">
          <svg
            width="10"
            height="11"
            viewBox="0 0 10 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.44434 5.49992L0.944336 10.4074L0.944336 0.592442L9.44434 5.49992Z"
              fill="white"
            />
          </svg>
        </span>
        <span class="next" @click="proceedVideo(5)">
          <svg
            width="8"
            height="9"
            viewBox="0 0 8 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.55566 4.49973L1.889 7.77138L1.889 1.22808L7.55566 4.49973Z"
              fill="white"
            />
            <path
              d="M7.55566 0.721954V8.27751"
              stroke="white"
              stroke-width="0.5"
            />
          </svg>
        </span>
      </div>
      <span class="full-screen" @click="fullScreen">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.95817 7.08332H3.5415V3.54166H7.08317V4.95832H4.95817V7.08332ZM3.5415 9.91666H4.95817V12.0417H7.08317V13.4583H3.5415V9.91666ZM12.0415 12.0417H9.9165V13.4583H13.4582V9.91666H12.0415V12.0417ZM9.9165 4.95832V3.54166H13.4582V7.08332H12.0415V4.95832H9.9165Z"
            fill="white"
          />
        </svg>
      </span>
    </div>
    <div v-else class="controls-custom-player controls-fullscreen">
      <div class="left-controls">
        <span class="prev" @click="proceedVideo(-5)">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 8.72193L13 15.6501L13 1.79372L1 8.72193Z"
              fill="white"
            />
            <path d="M1 0.721924V16.7219" stroke="white" stroke-width="0.5" />
          </svg>
        </span>
        <span class="play" @click="playVideo">
          <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 7L-1.19209e-06 13.9282L-1.19209e-06 0.0717968L12 7Z"
              fill="white"
            />
          </svg>
        </span>
        <span class="next" @click="proceedVideo(5)">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0002 8.72193L4.00024 15.6501L4.00024 1.79372L16.0002 8.72193Z"
              fill="white"
            />
            <path
              d="M16.0002 0.721924V16.7219"
              stroke="white"
              stroke-width="0.5"
            />
          </svg>
        </span>
      </div>
      <span class="full-screen" @click="fullScreen">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 10H5V5H10V7H7V10ZM5 14H7V17H10V19H5V14ZM17 17H14V19H19V14H17V17ZM14 7V5H19V10H17V7H14Z"
            fill="white"
          />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Player",
  props: {
    type: {
      default: "vimeo", // vimeo
      type: String
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      player: "",
      showLargeBtn: true,
      fullScreenMode: false
    };
  },
  created() {
    document.addEventListener("fullscreenchange", event => {
      if (document.fullscreenElement) {
        console.log(`Element:  entered fullscreen mode.`);
      } else {
        this.$refs.player.player.pause();
        this.showLargeBtn = true;
        this.fullScreenMode = false;
      }
    });
  },
  mounted() {
    this.player = this.$refs.player.player;
  },
  beforeDestroy() {
    let watchTime = this.$refs.player.player.currentTime;
    this.$emit("watchTime", watchTime);
  },
  methods: {
    playVideo() {
      if (this.$refs.player.player.playing) {
        this.$refs.player.player.pause();
        this.showLargeBtn = true;
      } else {
        this.showLargeBtn = false;
        this.$refs.player.player.play();
      }
    },
    fullScreen() {
      // this.$refs.player.player.fullscreen.enter();
      // this.$refs.player.player.fullscreen.active = true;
      let elem = document.querySelector(".custom-player");
      if (this.fullScreenMode) {
        document
          .exitFullscreen()
          .then(() => {
            this.fullScreenMode = false;
          })
          .catch(err => console.error(err));
      } else {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          this.fullScreenMode = true;
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
          this.fullScreenMode = true;
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
          this.fullScreenMode = true;
        }
      }
    },
    proceedVideo(time) {
      console.log(time);
      let watchTime = this.$refs.player.player.currentTime;
      this.$refs.player.player.currentTime = watchTime + time;
    }
  },
  watch: {
    id(newVal) {
      console.log("watch");
      this.$refs.player.player.source = {
        type: "video",
        sources: [
          {
            src: newVal,
            provider: this.id
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss">
.player-wrapper {
  position: relative;

  .player-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    //background: red;
  }
}

.custom-player {
  width: 100%;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  //.controls-fullscreen{
  //  display: none;
  //}
  //&.fullscreen{
  //  .controls-fullscreen{
  //    display: flex;
  //  }
  //  .controls-sm{
  //    display: none;
  //  }
  //}
  &::after {
    //content: '';
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }

  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    cursor: pointer;

    &:hover {
      transform: translate(-50%, -50%) scale(1.07);
    }
  }

  .controls-custom-player {
    position: absolute;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 18px;
    background: #090b3080;
    border-radius: 0 0 8px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 13px;

    &.controls-fullscreen {
      height: 32px;
    }

    span {
      cursor: pointer;

      &:hover {
        transform: scale(1.07);
      }
    }

    .left-controls {
      display: flex;
      column-gap: 8px;
    }
  }
}
</style>
